import * as React from 'react';
import { cn } from '../../lib/utils';

export interface ZafroiIconProps extends React.SVGAttributes<SVGSVGElement> {
  /** Pixel size. Defaults to 24. */
  size?: number;
  /** Mark tone — `dark` (default) sits on light surfaces; `light` for dark surfaces. */
  tone?: 'dark' | 'light';
}

/**
 * Compact ZAFROI mark — a stylized "Z" inside a rounded square. Used as a
 * favicon, in the app switcher trigger, and anywhere a wordmark would be too
 * heavy.
 */
export const ZafroiIcon = React.forwardRef<SVGSVGElement, ZafroiIconProps>(
  ({ size = 24, tone = 'dark', className, ...props }, ref) => {
    const surface = tone === 'dark' ? '#0f1317' : '#ffffff';
    const stroke = '#ff7a1a';
    return (
      <svg
        ref={ref}
        viewBox="0 0 32 32"
        width={size}
        height={size}
        role="img"
        aria-label="ZAFROI"
        className={cn('block', className)}
        {...props}
      >
        <rect width="32" height="32" rx="7" fill={surface} />
        <path
          d="M10 10h12l-9 12h9"
          stroke={stroke}
          strokeWidth={2.4}
          strokeLinecap="square"
          strokeLinejoin="miter"
          fill="none"
        />
      </svg>
    );
  },
);
ZafroiIcon.displayName = 'ZafroiIcon';
